import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import LeadCard from './LeadCard';
import { Droppable } from './Droppable'; // CORREÇÃO: Importa o nosso wrapper customizado

const MarketingKanbanColumn = ({ column, leads, onCardClick }) => {
    return (
        <Card className="kanban-column shadow-sm"> {/* Use Card as the main column container */}
            <Card.Header
                className="d-flex justify-content-between align-items-center" // Adiciona flex para alinhar título e badge
                style={{ backgroundColor: column.color, color: 'white' }}
            >
                <span className="fw-bold">{column.title}</span> {/* Título da coluna */}
                <Badge bg="light" text="dark" pill>{leads.length}</Badge> {/* Contador de leads */}
            </Card.Header>
            <Card.Body className="kanban-column-body p-0"> {/* Remove padding padrão do Card.Body */}
                <Droppable droppableId={column.id}>
                    {(provided, snapshot) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            className="kanban-column-content" // Esta div conterá os cards e será alvo do CSS
                            style={{
                                background: snapshot.isDraggingOver ? '#e9ecef' : 'transparent', // Feedback visual ao arrastar sobre
                                minHeight: '500px', // Garante altura mínima para a área droppable
                                padding: '8px', // Adiciona padding interno à área de conteúdo
                            }}
                        >
                            {leads.map((lead, index) => (
                                 <LeadCard key={lead.id} lead={lead} index={index} onClick={onCardClick} />
                            ))}
                            {provided.placeholder}
                        
                        </div>
                    )}
                    
                </Droppable>
            </Card.Body>
        </Card>
    );
};

export default MarketingKanbanColumn;
